<template>
  <!-- Show Snapsheet templates pagwe without the layout -->
  <div class="cl" v-if="isSnapsheetsTemplatesRoute">
    <router-view v-if="has_dealer_info" />
  </div>
  <!-- Dashboard layout -->
  <div class="kt-grid kt-grid--hor kt-grid--root" v-else>
    <div
      class="kt-grid__item kt-grid__item--fluid kt-grid kt-grid--ver kt-page"
    >
      <div
        class="kt-grid__item kt-grid__item--fluid kt-grid kt-grid--hor kt-wrapper"
        id="kt_wrapper"
      >
        <HeaderMenu
          :has_dealer="has_dealer_info"
          v-if="!loading_dealer && showHeader"
        />
        <div
          class="kt-grid__item kt-grid__item--fluid kt-grid kt-grid--hor kt-grid--stretch"
        >
          <div
            class="kt-body kt-grid__item kt-grid__item--fluid kt-grid kt-grid--hor kt-grid--stretch"
            id="kt_body"
          >
            <div
              class="kt-grid__item kt-grid__item--fluid kt-grid kt-grid--hor"
              id="kt_content"
            >
              <!-- begin:: Content -->
              <router-view v-if="has_dealer_info" />
              <div v-else class="sign-up-form">
                <div class="kt-container kt-grid__item kt-grid__item--fluid">
                  <div class="row">
                    <div class="col">
                      <div
                        class="alert alert-light alert-elevate fade show"
                        role="alert"
                      >
                        <div class="alert-icon">
                          <i
                            class="kt-font-brand"
                            :class="{
                              'flaticon-questions-circular-button': accountid,
                              'flaticon-warning': !accountid,
                            }"
                          ></i>
                        </div>
                        <div class="alert-text">{{ dealer_message }}</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- end:: Content -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import HeaderMenu from "@/components/Dashboard/Header/HeaderMenu";
export default {
  name: "DashboardLayout",
  components: { HeaderMenu },

  computed: {
    ...mapState(["auth", "dealer"]),

    isSnapsheetsTemplatesRoute() {
      return this.$route.name === "SnapsheetsTemplates";
    },

    loading_dealer() {
      return !this.has_dealer_info;
    },

    has_dealer_info() {
      return this.auth.apiToken && Object.keys(this.dealer).length > 0;
    },

    dealer_message() {
      if (this.accountid) {
        if (!this.loading_dealer) {
          return "Please provide your company information";
        } else {
          return "Please wait, loading information";
        }
      }
      return "Missing Account Number";
    },

    accountid() {
      return this.$route.query.code;
    },

    showHeader() {
      return process.env.VUE_APP_SHOW_DASHBOARD_HEADER;
    },
  },

  methods: {
    ...mapActions("dealer", [
      "getFullDealerDataOrCreateItInDashboard",
      "updateDealer",
    ]),
  },
};
</script>

<style lang="scss">
.kt-grid--root {
  background: #efeff5;
}
</style>
